import { render, staticRenderFns } from "./RegulatoryMessage.vue?vue&type=template&id=16efc918"
import script from "./RegulatoryMessage.vue?vue&type=script&lang=js"
export * from "./RegulatoryMessage.vue?vue&type=script&lang=js"
import style0 from "./RegulatoryMessage.vue?vue&type=style&index=0&id=16efc918&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports